// eslint-disable-next-line import/no-anonymous-default-export
export default (state = {}, action) => {
  state = {
    data: null,
    ...state,
  };

  switch (action.type) {
    case 'SET_DB':
      const { payload: data } = action;
      return {
        ...state,
        data,
      };
    default:
      return state;
  }
}
